<template>
    <div class="sports_item_detail sports_register_detail">
        <div class="viewhover">
            <div class="label">同行人</div>
            <div>
                <van-field v-model="previous_checker" placeholder="请输入评估同行人" label="评估同行人" />
            </div>
        </div>
        <div class="viewhover">
            <div class="label">赛事评估信息</div>
            <Form :list="registerform" @submit="submit" @submit2="submit2" />
        </div>
                   
        <!-- <div class="label total viewhover">
            <div>
                <span>总分</span>
                <span>{{allnum}}</span>
            </div>
            <div>
                <span>得分</span>
                <span>{{score}}</span>
            </div>
        </div> -->
        <div class="viewhover">
            <div class="label">
                备注
            </div>
            <div class="boder">
                <van-field v-model="remark" placeholder="请输入备注信息"/>
            </div>
        </div>
        <!-- <div class="viewhover">
            <div class="label sign">
                <div>评估人员签字</div>
                <div class="btn" @click="clear">清除</div>
            </div>
            <div class="boder" v-touch:end="endHandler">
                <vueSignature ref="signature" :w="'100%'" :h="'2rem'" :sigOption="option"></vueSignature>
            </div>
        </div> -->
        
        
        <div style="height: 2rem;">&nbsp;</div> 
        <!-- <div class="sese">请参照示范视频角度及动作，正面/侧面拍摄动作，保证动作标准性，以便系统识别计分，谢谢</div> -->
    </div>
</template>

<script>
    import Footbar from '@/components/footbar/index'
    import Form from '@/components/form/index.vue'
    import {Empty, Panel, Cell, Button, CellGroup, Field} from 'vant';
    import Params from '@/libs/params'
    import vueSignature from "vue-signature"
    import moment from 'moment';
    

    import "./index.less"

    export default {
        computed: {
            buttonColor() {
                return `#0598D6`;
            }
        },
        components: {
            Empty,
            Panel,
            VanCell:Cell,
            Button,
            VanCellGroup:CellGroup,
            Footbar,
            Form,
            VanField: Field,
            vueSignature
        },
        data() {
            return {
                detail: '',
                itemDetail: "",
                evid: '',
                matchid: '',
                title: '',
                registerform: [],
                option: {
                    panColor: "rgb(0,0,0)",
                    bacgroundColor: "rgb(245,245,245)"
                },                
                allnum: 0,
                score: 0,
                address: '',
                previous_checker: '',
                userInfo: {},
                principal: '',
                appraiser: '',
                remark: ''
            }
        },
        methods: {
            clear() {
                if(this.appraiser) {
                    this.$refs.signature.clear();
                    this.appraiser = ''
                }
                
            },
            endHandler() {
                var png = this.$refs.signature.save()
                let file = {
                    content: png,
                    imgkey: 'file'
                }
                this.$api.system.upload(file).then(res=>{
                    this.appraiser = res.data.imgurl
                })
            },
            submit: function (e) {
                // if(this.appraiser == '') {
                //     this.$toast.fail('表单显示不完整，请完善信息')
                //     return
                // }
                // if(this.previous_checker=='') {
                //     this.$toast.fail('表单显示不完整，请完善信息')
                //     return
                // }
                let that = this
                this.$dialog.confirm({
                    title: '标题',
                    message: '确认提交？',
                })
                .then(() => {
                    // on confirm
                    this.$toast.loading({
                        message: "加载中...",
                        forbidClick: true,
                        duration: 0, // 持续展示 toast
                    });
                    
                    var score = 0
                    let query = {
                        // appraiser:this.appraiser,
                        step:2,
                        score,
                        base_id: that.matchid,
                        registerform: JSON.stringify(e),
                        previous_checker: that.previous_checker,
                        id: that.evid,
                        status: 1,
                        remark: that.remark
                    }
                    that.$api.match.editEnv(query).then((res) => {
                        that.$toast.clear();
                        if (res.success) {
                            that.$toast.success('成功');
                            that.$router.replace({ name: 'index'})
                        }
                        
                    })
                })
                .catch(() => {
                    // on cancel
                });
                
                // var hide = false
                // e.forEach(item=>{
                //     if(item.key_name === "identifying" && item.value == 1) {
                //         hide = true
                //     }
                //     if(item.type==1) {
                //         score += item.value*1
                //     }
                // })
                // this.score = hide?0:score
                
                    
            },
            submit2: function (e) {
                // if(this.appraiser == '') {
                //     this.$toast.fail('表单显示不完整，请完善信息')
                //     return
                // }
                // if(this.previous_checker=='') {
                //     this.$toast.fail('表单显示不完整，请完善信息')
                //     return
                // }
                this.$toast.loading({
                    message: "加载中...",
                    forbidClick: true,
                    duration: 0, // 持续展示 toast
                });
                let that = this
                var score = 0
                // var hide = false
                // e.forEach(item=>{
                //     if(item.key_name === "identifying" && item.value == 1) {
                //         hide = true
                //     }
                //     if(item.type==1) {
                //         score += item.value*1
                //     }
                // })
                // this.score = hide?0:score
        
                let query = {
                    // appraiser:this.appraiser,
                    remark:this.remark,
                    step:2,
                    score,
                    base_id: this.matchid,
                    registerform: JSON.stringify(e),
                    previous_checker: this.previous_checker,
                    id: this.evid,
                    status: 2,
                    remark: this.remark
                }
                this.$api.match.editEnv(query).then((res) => {
                    this.$toast.clear();
                    if (res.success) {
                        this.$toast.success('成功');
                        this.$router.replace({ name: 'index'})
                    }
                    
                })
                    
            },
            init: function () {
                this.$toast.loading({
                    duration: 0
                });
                let params = {evid: this.evid}
                this.$api.match.getEnvDetail(params).then((res) => {
                    
                    let registerform = []
                    let arr = 0
                    if (res.data.registerform) {
                        try {
                            registerform = JSON.parse(res.data.registerform);
                        } catch (e) {
                            console.log(e)
                        }
                    } else {
                        if(res.data.match_plate_id== 3 || res.data.match_plate_id== 4) {
                            registerform = Params.attr
                        } else if (res.data.match_plate_id== 2) {
                            registerform = Params.brand
                        } else {
                            registerform = Params.league
                        }
                    }
                        
                    // registerform.forEach(item=>{
                    //     if(item.type==1) {
                    //         arr +=item.max*1
                    //     }
                    // })
                    // this.allnum = arr

                    this.registerform = registerform
                    this.$toast.clear();
                })
                

            },
            getinfo() {
                this.$api.user.getUserInfo().then(res=>{
                    this.userInfo = res.data
                })
            }
        },
        mounted() {
            this.evid = this.$route.params.evid
            this.matchid = this.$route.params.matchid
            this.init();
            this.getinfo()
        }

    }
</script>
